import styled, { css } from "styled-components";
import { COLOURS } from "../../variables/Colors";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { cursor } from "../../variables/Cursors";
import { setFlex } from "../../variables/Position";

const setWidth = width => {
  switch (width) {
    case "small":
      return css`
        width: 30%;
        @media (max-width: ${BREAKPOINTS.lg}px) {
          width: 35%;
        }
        @media (max-width: ${BREAKPOINTS.md}px) {
          width: 50%;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          width: 70%;
        }
      `;
    case "medium":
      return css`
        width: 50%;
        @media (max-width: ${BREAKPOINTS.md}px) {
          width: 70%;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          width: 80%;
        }
      `;
    case "large":
      return css`
        width: 80%;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          width: 100%;
        }
      `;
    case "xlarge":
      return css`
        width: 100%;
      `;
    default:
      return css``;
  }
};

const setFontSize = size => {
  switch (size) {
    case "small":
      return css`
        font-size: 0.8rem;
        line-height: 1.25rem;
      `;
    case "normal":
      return css`
        font-size: 1rem;
        line-height: 1.45rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 0.95rem;
          line-height: 1.4rem;
        }
      `;
    case "medium":
      return css`
        font-size: 1.3rem;
        line-height: 1.75rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 1rem;
          line-height: 1.45rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 0.85rem;
          line-height: 1.3rem;
        }
      `;
    case "large":
      return css`
        font-size: 1.8rem;
        line-height: 1.85rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 1.6rem;
          line-height: 1.65rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 1.4rem;
          line-height: 1.45rem;
        }
      `;
    case "xlarge":
      return css`
        font-size: 3rem;
        line-height: 2.7rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 2rem;
          line-height: 1.7rem;
        }
      `;
    case "credits":
      return css`
        font-size: 1.3rem;
        line-height: 1.5rem;
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 1rem;
          line-height: 1.2rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 0.85rem;
          line-height: 1rem;
        }
      `;
    default:
      return css`
        font-size: 1rem;
        line-height: 1.45rem;
      `;
  }
};

const setFont = font => {
  switch (font) {
    case "normal":
      return css`
        font-family: "univers-lt-roman";
      `;
    case "deville":
      return css`
        font-family: hs-deville;
      `;
    default:
      return css`
        font-family: "univers-lt-roman";
      `;
  }
};

export const TextContainer = styled.div`
  ${props =>
    setFlex({
      justify: props.$justify || "center",
      align: props.$align || "center",
      direction: props.$direction,
    })};
  ${props => props.$padding && "padding-bottom: 1.5rem"};
  ${props =>
    props.$mobileColumn &&
    `
      @media (max-width: ${BREAKPOINTS.md}px) {
        ${setFlex({ direction: "column" })};
      }
  `};
`;

export const ParagraphContainer = styled.div`
  ${setFlex({ align: "flex-end" })};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ justify: "center", align: "center" })};
    width: 100%;
  }
`;

export const Paragraph = styled.p`
  font-family: "univers-lt-roman";
  color: ${COLOURS.primary.pink};
  margin: 0;
  text-align: ${props => props.$align};
  ${props => setWidth(props.$width)};
  ${props => setFontSize(props.$size)};
  ${props => setFont(props.$style)};
  ${props => props.$indent && "text-indent: 3em"};
  ${props => props.$margin && "margin-right: 4rem"};
  ${props => props.$bold && "font-weight: 850"};
  i {
    font-style: italic;
  }
  a {
    color: ${COLOURS.primary.pink}!important;
    font-weight: 850;
    text-decoration: underline;
    ${cursor("pointer")};
  }
`;

export const Span = styled.span`
  color: ${COLOURS.primary.pink};
  margin: 0;
  text-align: ${props => props.$align};
  ${props => setWidth(props.$width)};
  ${props => setFontSize(props.$size)};
  ${props => setFont(props.$style)};
  ${props => props.$indent && "text-indent: 3em"};
  ${props => props.$margin && "margin-right: 4rem"};
  ${props => props.$bold && "font-weight: 850"};
  i {
    font-style: italic;
  }
`;
